import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./i18n";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./utils/theme";
import { Provider } from "react-redux";
import store from "./redux/store";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import 'leaflet/dist/leaflet.css';


const addOmiseScript = () => {

  const scriptId = "omise-script";

  if (!document.getElementById(scriptId)) {
    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://cdn.omise.co/omise.js";
    script.async = true;
    script.onload = () => {
      if (window.OmiseCard) {
        window.OmiseCard.configure({
          publicKey: process.env.REACT_APP_PAYMENT_KEY,
        });
      }
    };
    script.onerror = () => {
      console.error("Failed to load Omise.js");
    };
    document.body.appendChild(script);
  }
};

console.log(process.env.REACT_APP_PAYMENT_KEY)
  addOmiseScript()



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </LocalizationProvider>
);
